<template>
  <div class="number w-100 d-flex flex-column align-items-center">
    <h-m-styled-plaintext
      v-model="selected"
      :name="name"
      :nav-choices="filterOptions"
      class="mb-3"
    ></h-m-styled-plaintext>
    <div v-if="selected === 'interval'" class="w-100 d-flex flex-column align-items-center">
      <h-f-fields
        v-model="actualScale"
        :model-select="scaleChoices"
        class="w-75 mb-3"
        input-type="model-select"
      ></h-f-fields>
      <vue-slider
        :key="sliderKey"
        v-model="range"
        :marks="actualRange"
        :max="actualRange[1]"
        :min="actualRange[0]"
        class="w-75 mb-3"
        :lazy="true"
        @change="updateRange"
      ></vue-slider>
    </div>
    <div v-else class="w-100 d-flex flex-column align-items-center">
      <h-f-fields v-model="number" class="w-75"></h-f-fields>
    </div>
  </div>
</template>

<script>
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'

export default {
  name: 'number-filter',

  components: {
    VueSlider,
  },

  props: {
    min: [Number, String],
    max: [Number, String],
    name: String,
  },

  data() {
    return {
      actualScale: '0to999',
      scaleChoices: [
        { text: '0-999', value: '0to999', array: [0, 999] },
        { text: '1000-49999', value: '1000to49999', array: [1000, 49999] },
        { text: '50000-99999', value: '50000to99999', array: [50000, 99999] },
      ],
      range: [0, 999],
      actualRange: [0, 999],
      sliderKey: 0,
      filterOptions: [
        { text: 'Plus grand', link: 'min', active: false },
        { text: 'Plus petit', link: 'max', active: false },
        { text: 'Égal', link: 'equal', active: false },
        { text: 'Intervalle', link: 'interval', active: false },
      ],
      selected: 'min',
      number: 0,
    }
  },

  watch: {
    actualScale() {
      for (let i = 0; i < this.scaleChoices.length; i++) {
        if (this.scaleChoices[i].value === this.actualScale) {
          this.range = this.scaleChoices[i].array
          this.actualRange = this.scaleChoices[i].array
          this.updateRange()
        }
      }
    },

    number() {
      this.formatFilter()
    },

    selected() {
      this.formatFilter()
    },
  },

  async mounted() {
    await this.$nextTick()
    if (this.min || this.max) {
      if (this.selected === 'min') {
        this.number = this.min
      } else if (this.selected === 'max') {
        this.number = this.max
      } else if (this.selected === 'equal') {
        this.number = this.min
      } else if (this.selected === 'interval') {
        this.range[0] = Number(this.min)
        this.range[1] = Number(this.max)
        this.sliderKey++
      }
    }
  },

  methods: {
    async updateRange() {
      await this.$nextTick()
      if (this.range[0] !== Number(this.min)) {
        this.$emit('update:min', this.range[0])
      }
      if (this.range[1] !== Number(this.max)) {
        this.$emit('update:max', this.range[1])
      }
    },

    async formatFilter() {
      await this.$nextTick()
      if (this.selected === 'min') {
        this.updateMin()
        this.updateMax(true)
      } else if (this.selected === 'max') {
        this.updateMin(true)
        this.updateMax()
      } else if (this.selected === 'equal') {
        this.updateMin()
        this.updateMax()
      }
    },

    updateMin(toNull) {
      if (this.number !== Number(this.min) && !toNull) {
        this.$emit('update:min', this.number)
      } else if (this.min !== null && toNull) {
        this.$emit('update:min', null)
      }
    },

    updateMax(toNull) {
      if (this.number !== Number(this.max) && !toNull) {
        this.$emit('update:max', this.number)
      } else if (toNull) {
        this.$emit('update:max', null)
      }
    },
  },
}
</script>

<style scoped></style>
